<template>
  <FKBreadCrumb :page="$t('page.delete_account')" />
  <RightToErasureForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import RightToErasureForm from "@/components/FK/Profile/RightToErasureForm.vue";

export default defineComponent({
  name: "RightToErasurePage",
  components: {
    FKBreadCrumb,
    RightToErasureForm
  },

});
</script>